import React from "react";
import { Card, Row, Col, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { ReduxState } from "../../../../redux";
import PageHeader from "../../../Docuclipper/PageHeader/PageHeader";

export const ReferralProgram: React.FC = () => {
  const { user } = useSelector((state: ReduxState) => state.User);

  if (!user) return null;

  return (
    <Container>
      <PageHeader
        title="Refer & Earn"
        description="Two ways to get rewarded for spreading the word about DocuClipper."
        topClassName="pt-3 pb-2"
        headerClassName="h3"
        titleMbClassName="mb-1"
      />

      <Row className="mb-4">
        <Col md={6} className="mb-3 mb-md-0">
          <Card className="h-100 shadow-sm">
            <Card.Body className="d-flex flex-column p-4">
              <div className="d-flex align-items-center mb-3">
                <FontAwesomeIcon
                  icon="dollar-sign"
                  size="2x"
                  className="text-primary mr-3"
                />
                <h4 className="mb-0">Earn 20% commission</h4>
              </div>
              <p className="text-muted">
                Join our affiliate program and earn 20% on every referral's
                first year. No cap, paid monthly.
              </p>
              <ul className="text-muted small mb-4 pl-3">
                <li>20% of the subscription fee for the first year</li>
                <li>Unlimited referrals, unlimited payouts</li>
                <li>Monthly payouts for qualifying referrals</li>
              </ul>
              <div className="mt-auto">
                <a
                  href="https://docuclipper.firstpromoter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                >
                  Sign up on the affiliate portal
                  <FontAwesomeIcon
                    icon="external-link-alt"
                    className="ml-2"
                  />
                </a>
                <div className="small text-muted mt-2">
                  Opens our partner site (FirstPromoter) in a new tab.
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <Card className="h-100 shadow-sm">
            <Card.Body className="d-flex flex-column p-4">
              <div className="d-flex align-items-center mb-3">
                <FontAwesomeIcon
                  icon="star"
                  size="2x"
                  className="text-warning mr-3"
                />
                <h4 className="mb-0">100 free pages for a review</h4>
              </div>
              <p className="text-muted">
                Leave a review of DocuClipper and we'll add 100 pages
                ($60 value) to your account.
              </p>
              <ol className="text-muted small mb-4 pl-3">
                <li className="mb-1">
                  Post a review on{" "}
                  <a
                    href="https://www.g2.com/products/docuclipper/reviews"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    G2
                  </a>{" "}
                  or, if you use QuickBooks Online,{" "}
                  <a
                    href="https://quickbooks.intuit.com/app/apps/appdetails/docuclipper/en-us/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Intuit App Store
                  </a>
                  .
                </li>
                <li className="mb-1">Take a screenshot of your review.</li>
                <li>
                  Email it to{" "}
                  <a href="mailto:support@docuclipper.com?subject=Review%20screenshot%20for%20100%20free%20pages">
                    support@docuclipper.com
                  </a>{" "}
                  and we'll credit your account.
                </li>
              </ol>
              <div className="mt-auto small text-muted">
                Need inspiration?{" "}
                <a
                  href="https://docuclipper.com/reviews"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  See what other users are saying
                </a>
                .
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ReferralProgram;
